<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container xl">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <p class="hdg02">ライセンス管理解除設定</p>
        </div>
        <div class="popup-content">
          <form @submit.prevent class="contract-container">
            <!-- {{disableUsers}} -->
            <div v-for="(product,index) in shortageList" :key="'product_' + index" class="contract-content">
              <p class="txt">有効期限終了後、ライセンスが不足します。<br>ライセンス管理設定数が次年のライセンス数を超えないように解除するアカウントのチェックを外してください。</p>
              <div class="contract-content-info">
                <div class="contract-content-info-title">
                  <h2 class="hdg02">{{product.name}}</h2>
                </div>
                <div class="contract-content-info-num">
                  <div class="contract-content-info-num-hdg">
                    <p>ライセンス管理設定数</p>
                    <p class="contract-content-info-num-hdg-txt"><span :class="[activeUsers[index].length > product.afterNum && 'max']">{{activeUsers[index].length}}</span> / <span>{{product.afterNum}}</span></p>
                    <p>次年のライセンス数</p>
                  </div>
                </div>
              </div>
              <div class="tbl01 contract-content-table">
                <table class="tbl fixed-header">
                  <tbody>
                    <tr v-for="(user, userIndex) in product.using_license" :key="'user_' + index + '_'+ userIndex">
                      <th>
                        <div class="contract-content-table-group">
                          <!-- <div class="formparts checkbox is-disabled"> -->
                          <div class="formparts checkbox">
                            <input type="checkbox" :value="user.user_id" :id="'cb_' + index + '_' + userIndex" v-model="activeUsers[index]">
                            <label :for="'cb_' + index + '_' + userIndex"><FontawesomeIcon icon="check" class="icn" /></label>
                          </div>
                          <label :for="'cb_' + index + '_' + userIndex"><span class="contract-content-table-group-label"  role="button">{{user.user_name}}</span></label>
                        </div>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="contract-footer">
              <p v-if="!isNoShortage()" class="txt-sup">ライセンス管理設定数が次年のライセンス数を超えています。正しい数になるまで解除するアカウントのチェックを外してください。</p>
              <div class="contract-submit">
                <span class="contract-submit-link" @click="close" role="button"><FontawesomeIcon :icon="['fas','angle-left']" class="icn" /> 戻る</span>
                <div :class="[!isNoShortage() && 'is-inactive']" class="button contract-submit-button">
                  <button class="btn" type="submit" @click="openViewConfirm" name="button">設定</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ServiceLicenseCancelInputInvalidUser } from '@/logic/contract/ServiceLicenseCancelInputInvalidUser'

export default defineComponent({
  name: 'PCServiceLicenseCancelInputInvalidUser',
  setup (props, context) {
    return { ...ServiceLicenseCancelInputInvalidUser(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.popup-wrapper{
  .popup-container{
    .popup-title{
      display: block;
      padding: 36px 116px 36px 40px;
      .txt{
        color: $color-sup;
      }
    }
  }
  .popup-content{
    padding: 40px;
  }
}
.contract {
  &-content {
    & + & {
      margin-top: 48px;
    }
    &-info {
      display: table;
      table-layout: fixed;
      width: 100%;
      margin: 32px 0 20px;
      &-notice {
        display: table-cell;
        vertical-align: bottom;
        font-size: 1.4rem;
        line-height: 1.57;
        color: $color-sup;
      }
      &-title {
        display: table-cell;
        .hdg02 {
          margin-bottom: 0;
        }
      }
      &-num {
        display: table-cell;
        vertical-align: bottom;
        text-align: right;
        padding: 0 18px;
        line-height: 1.57;
        &-hdg {
          display: flex;
          color: $color-sup;
          align-items: center;
          font-size: 1.4rem;
          float: right;
          p {
            margin-left: 12px;
          }
          &-txt {
            font-size: 2rem;
            color: $color-hdg;
            font-weight: bold;
            .max {
              color: $color-highlight;
            }
          }
        }
      }
    }
    &-table{
      table {
        border-top: 0;
      }
      thead{
        th{
          background: $color-bg-paper;
          border-bottom: 0;
        }
      }
      tbody{
        th{
          border-top: 1px solid $color-line;
          text-align: left;
          padding: 20px 20px;
        }
        td{
          span.txt-blue + span.txt-blue{
            margin-left: 35px;
            padding-left: 20px;
            border-left: 1px solid $color-line;
          }
        }
      }
      &-group{
        display: flex;
        align-items: center;
        label{
          height: 20px;
        }
        .checkbox{
          &.is-disabled{
            label{
              pointer-events: none;
              svg {
                display: none;
              }
              &:after{
                width: 12px;
                border-bottom: 1px solid $color-link;
                top: 50%;
                border-radius: 0;
                position: absolute;
                height: 0;
                background: none;
                left: 4px;
              }
            }
          }
        }
        &-label{
          padding-left: 20px;
          border-left: 1px solid $color-line;
          line-height: 22px;
          display: inline-block;
          color: $color-link;
          margin-left: 8px;
        }
        .txt-sup{
          margin-left: 20px;
          margin-bottom: 0;
        }
      }
    }
  }
  &-footer{
    border-top: solid 1px #ddd;
    margin-top: 48px;
    margin-left: -40px;
    margin-right: -40px;
    width: auto;
    padding: 0 40px;
    .txt-sup{
      text-align: center;
      margin-top: 45px;
      & + .contract-submit{
        margin-top: 14px;
      }
    }
  }
  &-submit {
    width: 314px;
    margin: 30px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &-link {
      width: 80px;
      display: flex;
      align-items: center;
      color: $color-link;
      font-size: 1.4rem;
      @include hoverOpacity;
      .icn {
        margin-right: 10px;
      }
    }
    &-button {
      width: 230px;
      .btn {
        font-size: 1.4rem;
        @include hoverOpacity;
        min-width: 230px;
      }
    }
  }
}
.fixed-header {
  tbody {
    display: block;
    max-height: 404px;
    overflow-y: scroll;
  }
  thead,
  tbody tr {
    display: table;
    width: 100%;
  }
}
</style>
